import React, { useEffect } from "react";
import "./Trade.scss";
import Select from "react-select";
import StatisticTable from "../../../../components/StatisticTable/StatisticTable";
import {
  customStylesSelect,
  loaderOverride,
  totalsRanges,
} from "../../../../utils/constants/constants";
import TotalRangePicker from "../../../../components/TotalRangePicker/TotalRangePicker";
import useTableContent from "./hooks/useTableContent";
import { MoonLoader } from "react-spinners";
import useTrade from "./hooks/useTrade";

import TradeItem from "../../../../components/TradeItem/TradeItem";
import TradeLegend from "../../../../components/TradeLegend/TradeLegend";

const Trade = () => {
  const {
    filterTypeSaved,
    fromSaved,
    toSaved,
    fromDate,
    toDate,
    isLoaded,
    selectorValue,
    isLoading,
    data,
    showRangePicker,
    dataBuy,
    dataSell,
    setSelectorValue,
    getTradesData,
    setIsLoaded,
    setShowRangePicker,
    getDateRange,
    setFromDate,
    setToDate,
  } = useTrade();
  const { sellTable, buyTable } = useTableContent(dataBuy, dataSell);

  useEffect(() => {
    if (filterTypeSaved && filterTypeSaved !== "null") {
      setSelectorValue(filterTypeSaved);
      getTradesData(fromSaved, toSaved);
    } else if (filterTypeSaved === "null" && fromSaved) {
      setSelectorValue("customized");
      getTradesData(fromSaved, toSaved);
    } else {
      getTradesData(fromDate, toDate);
    }
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    if (isLoaded) {
      if (selectorValue === "customized") {
        setSelectorValue("customized");
        return setShowRangePicker(true);
      }

      if (selectorValue) {
        const range = getDateRange(selectorValue);
        getTradesData(range.startDate, range.endDate);
      }
    }
  }, [selectorValue]);

  if (isLoading) {
    return (
      <div className="trade__loader">
        <MoonLoader
          color="#7236CD"
          loading={isLoading}
          cssOverride={loaderOverride}
          size={35}
        />
      </div>
    );
  }
  return (
    <div className="trade__wrapper">
      <div className="trade__tables">
        <StatisticTable data={buyTable} />
        <StatisticTable data={sellTable} />
      </div>
      <div className="trade__selector-wrapper">
        <span className="trade__selector-label">Period</span>
        <Select
          styles={customStylesSelect}
          options={totalsRanges}
          placeholder={"placeholder"}
          getOptionValue={(option) => option.value}
          onChange={(option) => {
            if (
              option.value === "customized" &&
              selectorValue === "customized"
            ) {
              setShowRangePicker(true);
            }

            setSelectorValue(option.value);
          }}
          value={totalsRanges.find((option) => option.value === selectorValue)}
        />
      </div>
      <div className="trade__items-table">
        <TradeLegend />
        {data
          ? Object.entries(data)
              .sort((a, b) => new Date(a[0]) - new Date(b[0]))
              ?.reverse()
              ?.map((el) => <TradeItem el={el} key={el[0]} />)
          : null}
      </div>
      {showRangePicker && (
        <TotalRangePicker
          showModal={showRangePicker}
          setShowModal={setShowRangePicker}
          getData={getTradesData}
          setFromDate={setFromDate}
          setToDate={setToDate}
          fromDate={fromDate}
          toDate={toDate}
        />
      )}
    </div>
  );
};

export default Trade;
